import { render, staticRenderFns } from "./CafeSubMenu.vue?vue&type=template&id=a571547e&"
import script from "./CafeSubMenu.vue?vue&type=script&lang=js&"
export * from "./CafeSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports